
export const MONTH_TH = "ม.ค.,ก.พ.,มี.ค.,เม.ย.,พ.ค.,มิ.ย.,ก.ค.,ส.ค.,ก.ย.,ต.ค.,พ.ย.,ธ.ค."
export const MONTH_TH_FULL = "มกราคม,กุมภาพันธ์,มีนาคม,เมษายน,พฤษภาคม,มิถุนายน,กรกฎาคม,สิงหาคม,กันยายน,ตุลาคม,พฤศจิกายน,ธันวาคม"

// dateString = "2021-08-10T00:00:00+07:00"
export const dateTHHMS = (dateString, fullText = false) => {
    if (!dateString) return ""

    const d = new Date(dateString)
    const dDMY = dateTH(dateString, fullText)
    const h = d.getHours().toString().padStart(2, '0')
    const m = d.getMinutes().toString().padStart(2, '0')

    if (fullText) {
        return `${dDMY} เวลา ${h}.${m} น.`
    } else {
        return `${dDMY} (${h}.${m})`
    }
}

// dateString = "2021-08-10T00:00:00+07:00"
export const dateTH = (dateString, fullText = false) => {
    if (!dateString) return ""
    const d = new Date(dateString)
    if (fullText) {
        const monthTH = MONTH_TH_FULL.split(",")[d.getMonth()]
        const be = (d.getFullYear() + 543)
        return `${d.getDate()} ${monthTH} ${be}`
    } else {

        const monthTH = MONTH_TH.split(",")[d.getMonth()]
        const be = (d.getFullYear() + 543) - 2500
        return `${d.getDate()} ${monthTH} ${be}`
    }
}